(() => { 
  const { createApp } = Vue;

  const V_PRODUCT_SELECTOR = '#v-product-main';
  let $v_product = document.querySelector(V_PRODUCT_SELECTOR);
  let $productJsonData = $v_product.querySelector('[data-product-json]');
  let product = JSON.parse($productJsonData.value);
  let options_with_values = JSON.parse($v_product.querySelector('[data-product-options-with-values-json]').value);
  product.options_with_values = options_with_values;

  let $selectedVariantJsonData = $v_product.querySelector('[data-selected-variant-json]');
  product.selected_variant = JSON.parse($selectedVariantJsonData.value);

  let $variantsMetafieldData = $v_product.querySelector('[data-variants-metafields]');
  let variantsMetafieldData = JSON.parse($variantsMetafieldData.value);

  let $productMainWrap = document.querySelector('#product-main');
  const RV_key = 'recently-viewed';
  let RV_items = JSON.parse(localStorage.getItem(RV_key)) || [];
  let RV_max_items = 6;
  let selected_variant_inventory;
  createApp({
    delimiters: ['${', '}'],
    data() {
      return {
        product,
        swiper_main: null,
        swiper_related_products: null,
        variantsMetafieldData,
        RV_items,
        RV_products: []
      };
    },

    computed: {
      selected_variant() {
        return this.product.selected_variant;
        
      },
      size_option() { 
        return this.product.options_with_values.find(op => op.name == 'Size');
      },
      isSelectedVariantLowStock() {

        let vm = this;
        let isSelectedVariantLowStock = false;
        let variant_data = vm.variantsMetafieldData.find(item => item.variant_id == vm.selected_variant.id);
        if (variant_data) {
          let inventory = variant_data.inventory_qty;
          isSelectedVariantLowStock = inventory > 0 && inventory < 8;
        }
        return isSelectedVariantLowStock;
      },
      isProductSoldout() {
        return !this.product.available;
      }
    },

    watch: {
      isSelectedVariantLowStock() { 
        this.updateVariantLowStock();
      }
    },

    mounted() {
      this.initSwiperMain();
      this.initDOMevents();
      this.initSwiperRelatedProducts();
      this.addRecentlyViewed();
      this.getRecentlyViewedProductsJS();
      this.updateVariantLowStock();
      this.variantChangeEvents();
      this.initDropdowns();
    },

    methods: {
      initDropdowns() {
        $('.select-custom select').each((index, select) => {
          let $select = $(select);
          $select.selectric({
            disableOnMobile: false,
            nativeOnMobile: true,
            onInit() {
              $select.closest('.selectric-wrapper').find('b').after('<span class="caret"></span>');
            },
            onChange(target) {
              target.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });
      },
      initDOMevents() {
        let vm = this;
        vm.notifyFormEvents();
      },
      variantChangeEvents() { 
        let vm = this;
        document.addEventListener('variant:change', (e) => {
          vm.updateVariantLowStock();
          vm.updateButtonState();
        });

      },
      notifyFormEvents() { 
        let vm = this;
        document.addEventListener('variant:change', (e) => {
          let $notify = document.querySelector('.product-notify-stock');
          if (!$notify) return;

          let $summary = $notify.querySelector('summary');
          if (!$summary) return;

          let $details = $notify.querySelector('details');
          if (!$details) return;

          let variant = e.detail.variant;
          // clear all previously selected
          $notify.querySelectorAll('input:checked').forEach(($input) => {
            $input.checked = false;
          });

          if (!variant.available) {
            let $size = $notify.querySelector(`input[name="size"][data-variant="${variant.id}"]`);
            $size.checked = true;
            $details.setAttribute('open', true);
          }
          else {
            $details.removeAttribute('open');
          }

          // update product selected_variant
          vm.product.selected_variant = variant;
        });

        // Mobile soldout btn click scroll to notify form
        if (vm.isProductSoldout && Shopify.theme.utils.checkIfMobileView()) {
          document.querySelectorAll('.product-form__submit.isSoldout').forEach(($buttonwrap) => { 
            $buttonwrap.addEventListener('click', (e) => { 
              e.preventDefault();
              let offsetTop = document.querySelector('.product-notify-stock').offsetTop;
              window.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
              });
            });
          });
        }
      },
      initSwiperMain() {
        let vm = this;
        vm.swiper_main = new Swiper('.swiper-product-images', {
          loop: true,
          pagination: {
            el: '.swiper-product-images .swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-product-images .swiper-button-next',
            prevEl: '.swiper-product-images .swiper-button-prev',
          },
          breakpoints: {},
          on: {
          }
        });

        document.querySelectorAll('.product-images-thumbs .product-thumb').forEach(($thumb) => { 
          $thumb.addEventListener('click', (e) => {
            let index = e.currentTarget.dataset.index;
            vm.slideTo(index);
          });
        });
      },
      initSwiperRelatedProducts() {
        this.swiper_related_products = new Swiper('.related-produts-swiper', {
          loop: true,
          slidesPerView: 3,
          spaceBetween: 5,
          pagination: {},
          navigation: {},
          breakpoints: {
            1024: {
              slidesPerView: 4,
              spaceBetween: 10
            },
            1365: {
              slidesPerView: 6,
              spaceBetween: 10
            }
          },
          navigation: {
            nextEl: '.related-produts-swiper .swiper-button-next',
            prevEl: '.related-produts-swiper .swiper-button-prev',
          },
          on: {}
        });
      },
      slideTo(index) {
        this.swiper_main.slideTo(index);
      },
      submitBackinStockForm(e) {
        Shopify.theme.utils.submitBackinStockForm(e);
      },
      addRecentlyViewed() {
        let vm = this;
        let productInList = vm.RV_items.map(item => item.handle).indexOf(vm.product.handle) !== -1;
        if (!productInList) {
          let RV_item = { handle: vm.product.handle };
          RV_items.unshift(RV_item);
          localStorage.setItem(RV_key, JSON.stringify(RV_items));
        }
      },
      getRecentlyViewedProductsJS() {
        let vm = this;
        let RV_promises = vm.RV_items.map(p => fetch(`/products/${p.handle}.js`).then(res => res.text()));
        let RV_products = [];
        Promise.all(RV_promises)
          .then((res) => {
            res.filter(item => item)
              .forEach((item) => { 
                let item_json = JSON.parse(item);
                if (item_json.handle != vm.product.handle) {
                  RV_products.push(JSON.parse(item));
                }
              });
          })
          .catch(console.error)
          .finally(() => {
            vm.RV_products = RV_products.slice(0, RV_max_items);
          });
      },
      updateVariantLowStock() { 
        let vm = this;
        if (!vm.size_option) {
          return;
        }
        // let size = vm.selected_variant['option' + vm.size_option.position];
        let size = document.querySelector('[data-option="size"] input:checked').value;
        let $variantRadios = $productMainWrap.querySelector('variant-radios');
        let $size = $productMainWrap.querySelector(`input[value="${size}"] + label`);
        let offsetLeft = 0;
        if ($variantRadios && $size) {
          let container_offsetLeft = $variantRadios.offsetLeft;
          let input_offsetLeft = $size.offsetLeft;
          offsetLeft = input_offsetLeft - container_offsetLeft;
          
        }

        $productMainWrap.querySelectorAll('.low-stock').forEach(($stock) => {
          
          let isSelectedVariantLowStock = false;
          
          setTimeout(_=>{
            let variant_data = vm.variantsMetafieldData.find(item => item.variant_id == parseInt(document.querySelector('product-form.product-form input[name="id"]').value));
            if (variant_data) {
              let inventory = variant_data.inventory_qty;
              selected_variant_inventory = inventory;
              isSelectedVariantLowStock = inventory > 0 && inventory < 8;
            }
            $stock.classList[isSelectedVariantLowStock ? 'add' : 'remove']('visible');
            $stock.style.marginLeft = `${offsetLeft}px`;

          });
          },100)
        
      },
      updateButtonState() { 
        let vm = this;
        let isSoldout = vm.selected_variant.available == false;
        if(isSoldout){
          if($productMainWrap.querySelector('.product-form-wrap square-placement'))$productMainWrap.querySelector('.product-form-wrap square-placement').style.height="0";
          if($productMainWrap.querySelector('[data-shopify="payment-button"]'))$productMainWrap.querySelector('[data-shopify="payment-button"]').style.display="none";
        }else{
          if($productMainWrap.querySelector('.product-form-wrap square-placement'))$productMainWrap.querySelector('.product-form-wrap square-placement').style.height=null;
          if($productMainWrap.querySelector('[data-shopify="payment-button"]'))$productMainWrap.querySelector('[data-shopify="payment-button"]').style.display="block";
        }
        // $productMainWrap.querySelector('.product-form__submit span').textContent = isSoldout ? 'Sold Out' : 'Add to bag';
        setTimeout(f=>{
          if(isSoldout){
            $productMainWrap.querySelector('.product-form__submit span').textContent = 'Sold Out';
          }else{
            if(typeof selected_variant_inventory != 'undefined' && selected_variant_inventory <= 0){
              if($productMainWrap.querySelector('.product-form__submit span'))$productMainWrap.querySelector('.product-form__submit span').textContent = 'Pre-order';
              if($productMainWrap.querySelector('input[name="properties[]"]'))$productMainWrap.querySelector('input[name="properties[]"]').disabled = false;
            }else{
              if($productMainWrap.querySelector('.product-form__submit span'))$productMainWrap.querySelector('.product-form__submit span').textContent = 'Add to bag';
              if($productMainWrap.querySelector('input[name="properties[]"]'))$productMainWrap.querySelector('input[name="properties[]"]').disabled = true;
  
            }
          }
        },100)
      }
    }
  }).mount(V_PRODUCT_SELECTOR);
})();